import { render, staticRenderFns } from "./Titlebar.vue?vue&type=template&id=576272b5&scoped=true"
import script from "./Titlebar.vue?vue&type=script&lang=js"
export * from "./Titlebar.vue?vue&type=script&lang=js"
import style0 from "./Titlebar.vue?vue&type=style&index=0&id=576272b5&prod&scoped=true&lang=css"
import style1 from "./Titlebar.vue?vue&type=style&index=1&id=576272b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576272b5",
  null
  
)

export default component.exports